const ITEMS = ["Sourcing", "Development", "Costing", "Production", "Quality Control", "Final Shipment"];

export const Marquee = ({ dark = false }) => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden border-y py-8 md:py-10 ${dark ? "border-stone-800 bg-ink" : "border-stone-200 bg-ivory"}`}
    >
      <div className="flex w-max animate-marquee items-center gap-10 md:gap-16">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10 md:gap-16" aria-hidden={half === 1}>
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10 md:gap-16">
                <span className={`whitespace-nowrap font-serif text-3xl md:text-5xl ${dark ? "text-stone-600" : "text-stone-400"}`}>
                  {item}
                </span>
                <span className="h-1.5 w-1.5 rounded-full bg-terra" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
